import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import api from "../../utils/api";
import { StringNumber, TGrupoMinisterio } from "../../types";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";



export const SelectMinisterioGrupo = ({ action, valor: _val }: { action: any, valor?: StringNumber | null | undefined }) => {

  const getMinisterio = async (): Promise<TGrupoMinisterio[] | []> => {
    try {
      const req = await api.get<TGrupoMinisterio[]>('ministerio/grupo');
      const res = req?.data;
      return res?.map(el => ({ ...el, descricao: `${el?.descricao} | ${el?.nomesede?.replace('CN', '')}` }));
    } catch (error) {
      return []
    }
  }

  const { data: ministerios } = useQuery({
    queryKey: ['miniterio-select-list'],
    queryFn: getMinisterio
  })

  const Selected = useCallback(() => {
    return (
      <>
        {
          ministerios && (
            <Select
              defaultValue={_val}
              value={_val}
              onChange={action}
            >
              {
                ministerios?.map(
                  ministerio =>
                    <MenuItem value={ministerio?.id}>
                      {ministerio?.descricao}
                    </MenuItem>
                )
              }
            </Select>
          )
        }
      </>
    )
  }, [_val, ministerios])

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Ministério</FormLabel>
        <Selected />
      </Grid>
    </>
  )
}
